import html2canvas from "html2canvas";
import Sigma from "sigma";

function captureWithPreserve(cb: () => void) {
  const original = HTMLCanvasElement.prototype.getContext;

  HTMLCanvasElement.prototype.getContext = function (type: string, attrs?: any): any {
    console.log("patched getContext() for type: ", type, " with attrs: ", attrs, "");
    if (type === "webgl" || type === "webgl2") {
      return original.call(this, type, {...(attrs || {}), preserveDrawingBuffer: true});
    }
    return original.call(this, type, attrs);
  };

  try {
    cb();
  } finally {
    console.log("restored getContext()");
    HTMLCanvasElement.prototype.getContext = original; // restore
  }
}

// Function to capture a screenshot of the current view
async function captureScreenshot(): Promise<Blob> {
  // Set the container to the root element of the app so we capture buttons and other UI elements
  const container = document.querySelector("#page-content") as HTMLElement;
  if (!container) throw new Error("#page-content not found");
  // Use html2canvas to capture the screenshot
  const canvas = await html2canvas(container, {
    backgroundColor: "#000000",
    useCORS: true,
    scale: 3  // Increase scale for better quality
  });

  return new Promise((resolve, reject) => {
    canvas.toBlob((blob) => {
      if (blob) resolve(blob);
      else reject(new Error("Failed to create screenshot blob"));
    });
  });
}

const useScreenshotPng = (sigma?: Sigma | null) => {
  return (): Promise<Blob> => {
    return new Promise((resolve, reject) => {
      try {
        captureWithPreserve(() => {
          sigma?.refresh();
          requestAnimationFrame(() => {
            captureScreenshot()
              .then(resolve)
              .catch(reject);
          });
        });
      } catch (err) {
        reject(err);
      }
    });
  }
};

export default useScreenshotPng;
